import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VuetifyDialog from 'vuetify-dialog'
import VueTimeago from 'vue-timeago'
import config from './config.js'
import coreConfig from "@core/config/app.config.js";
import constants from './constants.js'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import Faye from 'faye'
import VueCharts from 'vue-chartjs'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import commonFunctions from './commonFunctions.js'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import axios from 'axios'
import { injectFilters, injectInjectables, registerDirectives, verifyAccountCluster } from '@/utils.js'

import keycloak from "@core/config/keycloak-config";

Vue.use(Datetime)
Vue.use(Faye)
Vue.use(vueNumeralFilterInstaller)
Vue.use(VueCharts)
Vue.use(VuetifyDialog, { context: { vuetify } })
Vue.use(VueTimeago, {
  name: 'Timeago',
})

Vue.prototype.$config = config
Vue.prototype.$core = {
  config: coreConfig
}
Vue.prototype.$constants = constants
Vue.config.productionTip = false

/**
  * Injects filters and injectables in the vue instance globally
*/
injectFilters()
injectInjectables()
registerDirectives()


Vue.filter('timeToWords', function (value) {
  const time = value.split(':')

  if (+time[0] === 0 && +time[1] === 0) {
    return 'less than a minute'
  } else {
    if (+time[0] > 0) {
      return 'about ' + time[0] + ' hour' + (+time[0] > 1 ? 's' : '')
    }
    if (+time[1] > 0) {
      return 'about ' + time[1] + ' minute' + (+time[1] > 1 ? 's' : '')
    }
  }
})

Vue.filter('nullToZero', function (value) {
  if (value === null) {
    return 0
  }
  return value
})

Vue.filter('nl2br', function (value, arg1) {
  if (value) {
    value = value.replace(/(?:\r\n|\r|\n)/g, '<br>')
    return value
  }
})

Vue.filter('percent', function (value) {
  value = (!value || isNaN(value)) ? '0.00%' : value.toFixed(2).concat('%')
  return value
})

Vue.filter('wordUpperCase', function(str){
  return str.replace(/(?:^|\s)\S/g, (match) => { return match.toUpperCase(); });
})

const now = new Date()
let time = now.getTime()
time += 2592000000
now.setTime(time)
document.cookie =
  'liquid-sky=yes; expires=' +
  now.toUTCString() +
  ';domain=' +
  coreConfig.COOKIE_DOMAIN +
  ';path=/;'

  keycloak.init({
    onLoad: "check-sso",
    checkLoginIframe : false
  }).then((authenticated)=>{
    if (!authenticated) {
      keycloak.login();
      return
    }
    // Attach the Keycloak instance to Vue's prototype for global access
    Vue.prototype.$keycloak = keycloak;
    mountVueApp();
  }).catch(err=>{
    mountVueApp(); // Mount the app even if Keycloak fails
    setTimeout(() => { 
      router.replace('/authentication')
    })
    document.getElementById("splash").style.display = "none";
    console.error('Auth service initialization failed.', err)
  })


  // Helper function to mount the Vue application
const mountVueApp = () => {
  new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
